import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
export const Section = React.forwardRef(({ padding = 'regular', edgeToEdge, hideOverflow, className, ...props }, ref) => (_jsx("div", { className: cn(hideOverflow && 'overflow-x-hidden'), children: _jsx("section", { ref: ref, className: cn(!edgeToEdge && 'mx-auto w-full max-w-360 px-6 md:px-10 xl:px-25', 'py-10', padding === 'small' ? 'md:py-10' : 'md:py-20', className), ...props }) })));
Section.displayName = 'Section';
